import React from 'react';
import ReactDOM from 'react-dom';
import DataTable from '../DataTable/DataTable';
import FormList from '../FormList/FormList';
import ButtonList from '../Button/ButtonList';
import ListLoad from '../ListLoad/ListLoad';
import { Icon, Nav, Content, Page, Loading } from '@beisen/chaos-ui';
import * as helper from '../util/helper';
import * as urlHelper from '../util/url';
import { ExtensionWrap, getExtensionCmp } from '../util/extension';
import BSNav from '../PageNav/Nav';
import ErrorPage from '../ErrorPage/ErrorPage';
import * as pageError from '../util/pageError';
import debounce from 'lodash/debounce';
class PageModule extends React.Component {
    constructor(props) {
        super(props);
        this.getData(props);
        this.reloadTable = this.reloadTable.bind(this);
        this.displayToTop = this.displayToTop.bind(this);
        this.hideToTop = this.hideToTop.bind(this);
        this.handleToTop = this.handleToTop.bind(this);
        this.display = 'none';
        this.windowHeight = window.innerHeight;
    }

    fetchPageModule() {
        const {queryUrl, actions} = this.props;
        const { metaKey, viewName, metaObjName, pObjectDataID, currentDetailPageViewName,formState } = queryUrl;
        actions.fetchDataAndMountToBasePage(metaKey,{
            formState,
            viewName,
            metaObjName,
            'id': pObjectDataID,
            'detailViewName': currentDetailPageViewName
        },helper.getAPI('FetchPageModule'));
    }

    componentDidMount() {
        this.contentHeight =
            (this.refs.pageContent &&
                ReactDOM.findDOMNode(this.refs.pageContent).offsetHeight) ||
            0;
        this.fetchPageModule();
        if (window.env.platform.bsAppIOS) {
            window.env.on(
                {
                    name: 'viewappear'
                },
                () => {
                    this.reloadTable({
                        sortData:
                            this.TableList &&
                            this.TableList.cmp_data &&
                            this.TableList.cmp_data.sort_fields
                    });
                }
            );
        }
        if (this.refs.pageContent) {
            this.registerScrollEvent();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (
            !nextProps.isFetching &&
            this.props.isFetching &&
            !nextProps.error
        ) {
            this.isNeedReloadTable = true;
        }
        this.getData(nextProps);
    }

    componentDidUpdate() {
        if (this.isNeedReloadTable) {
            this.reloadTable({
                sortData:
                    this.TableList &&
                    this.TableList.cmp_data &&
                    this.TableList.cmp_data.sort_fields
            });
            this.isNeedReloadTable = false;
        }
        if (!this.registedScrollEvent) {
            this.registerScrollEvent();
        }
    }

    getScrollParent() {
        if (this.refs.pageContent) {
            return ReactDOM.findDOMNode(this.refs.pageContent);
        }
    }

    componentWillUnmount() {
        if (this.refs.pageContent) {
            this.getScrollParent().removeEventListener(
                'scroll',
                () => {
                    this.scrollHandler();
                },
                false
            );
        }
    }

    registerScrollEvent() {
        if (this.refs.pageContent) {
            this.getScrollParent().addEventListener(
                'scroll',
                debounce(this.scrollHandler.bind(this), 300),
                false
            );
            this.registedScrollEvent = true;
        }
    }

    scrollHandler() {
        if (this.refs.pageContent) {
            if (this.getScrollParent().scrollTop > 2 * this.windowHeight) {
                if (this.display == 'none') {
                    this.displayToTop();
                    this.display = 'block';
                }
            } else {
                if (this.display == 'block') {
                    this.hideToTop();
                    this.display = 'none';
                }
            }
        }
    }

    getData(props) {
        let { cmp_data, sub_cmps, queryUrl } = props;
        if (cmp_data && cmp_data.title) {
            this.NavTitle = cmp_data.title;
        }
        if (sub_cmps && sub_cmps.length > 0) {
            sub_cmps.forEach(item => {
                if (item.cmp_type == 'Form') {
                    this['TableList'] = item;
                    this.isNeedReloadTable = false;
                    this['TableList']['biz_data'] = props.biz_data;
                } else {
                    this[item.cmp_type] = item;
                }
            });
        }
        this.cmpContext = {};
        if (queryUrl.pObjectDataID) {
            this.cmpContext.pObjectDataID = queryUrl.pObjectDataID;
        }

        if (queryUrl.moduleID) {
            this.TableList && (this.TableList['moduleID'] = queryUrl.moduleID);
        }

        if (this.TableList && this.TableList.cmp_data) {
            const { viewName } = this.TableList.cmp_data;
            this.cmpContext.viewName = viewName;
            this.cmpContext.metaObjName =
                this.TableList.cmp_data.metaObjName ||
                this.TableList.cmp_data.metaObjectName; //table读取metaObjName form读取metaObjectName
            this.cmpContext.sortData = this.TableList.cmp_data.sort_fields;
        }
    }

    getNav() {
        let { cmp_data } = this.props;
        if (window.parent != window.self) {
            return null;
        }
        return <BSNav title={this.NavTitle} />;
    }

    reloadTable(data) {
        if (this.refs.table) {
            this.refs.table.reloadTable(data);
        } else {
            this.fetchPageModule();
        }
    }

    handleToTop() {
        this.refs.table &&
            this.refs.table.handleToTop &&
            this.refs.table.handleToTop();
        this.refs.pageContent && (this.getScrollParent().scrollTop = 0);
    }

    displayToTop() {
        this.refs.toTop && (this.refs.toTop.style.opacity = '1');
    }

    hideToTop() {
        this.refs.toTop && (this.refs.toTop.style.opacity = '0');
    }

    getList() {
        if (this.TableList) {
            const tableAjaxParam = {
                page_context: {
                    metaObjName: this.props.queryUrl.metaObjName,
                    // "viewName": this.props.queryUrl.detailViewName,
                    viewName:
                        this.props.queryUrl.mainDetailViewName ||
                        this.props.queryUrl.detailViewName,
                    DataId: this.props.queryUrl.pObjectDataID,
                    currentDetailPageViewName: this.props.queryUrl
                        .currentDetailPageViewName
                }
            };

            if (this.TableList.cmp_type == 'Form') {
                return (
                    <Content ref="pageContent">
                        <ExtensionWrap
                            {...this.TableList}
                            actions={this.props.actions}
                            queryUrl={this.props.queryUrl}
                            reloadFormList={this.fetchPageModule}
                        >
                            <FormList
                                {...this.TableList}
                                ref="formList"
                            />
                        </ExtensionWrap>
                    </Content>
                );
            }
            const DestCmp = getExtensionCmp(this.TableList) || DataTable;
            return (
                <Content>
                    <DestCmp
                        ref="table"
                        {...this.TableList}
                        actions={this.props.actions}
                        cmpContext={this.cmpContext}
                        queryUrl={this.props.queryUrl}
                        tableAjaxParam={tableAjaxParam}
                        loadData={true}
                        isFetching={
                            this.props.isFetching ||
                            this.TableList.isFetching ||
                            this.isNeedReloadTable
                        }
                        allowPTR={true}
                        noBottomButton={this.hasButton}
                        displayToTop={this.displayToTop}
                        hideToTop={this.hideToTop}
                        partId={this.props.cmp_data.viewName}
                    />
                </Content>
            );
        }
        return null;
    }

    existButton() {
        if (
            !this.ButtonList ||
            !this.ButtonList.sub_cmps ||
            this.ButtonList.sub_cmps.length == 0
        ) {
            return null;
        }

        const visbleArr = this.ButtonList.sub_cmps.filter(item => {
            if (item.cmp_data && item.cmp_data.visible) {
                return true;
            }
        });

        return visbleArr.length > 0 ? true : false;
    }

    getButtonList() {
        if (!this.existButton()) {
            return null;
        }

        this.hasButton = this.existButton();
        return (
            <ButtonList
                actions={this.props.actions}
                {...this.ButtonList}
                data={this.TableList}
                cmpContext={this.cmpContext}
                queryUrl={this.props.queryUrl}
                afterAction={this.reloadTable}
                getScrollTop={() => {}}
                pageCode={this.props.cmp_data.currentDetailPageViewName}
                pageName={this.props.cmp_data.title}
                partId={this.props.cmp_data.viewName}
            />
        );
    }

    renderError() {
        return pageError.errorPage(this.props);
    }

    render() {
        let { cmp_id, sub_cmps, cmp_type } = this.props;
        if (!cmp_id || !sub_cmps) {
            return (
                <Page cls="index-page">
                    <Content>
                        <ListLoad />
                    </Content>
                </Page>
            );
        }

        let errorPageNode = this.renderError();
        if (errorPageNode) {
            return (
                <Page cls="index-page">
                    {this.getNav()}
                    {errorPageNode}
                </Page>
            );
        }
        return (
            <Page cls="index-page">
                {this.getNav()}
                {this.getList()}
                {this.getButtonList()}
                {this.props.children}
                <div
                    className="toTop"
                    ref="toTop"
                    onTouchTap={this.handleToTop}
                />
            </Page>
        );
    }
}

PageModule.contextTypes = {
    actions: React.PropTypes.object.isRequired
};
export default PageModule;



// WEBPACK FOOTER //
// ./src/components/PageModule/PageModule.js